/**
 * Player detail error state container component
 *
 * Thin pass-through container that forwards props to the View. Follows the
 * Container/View pattern for consistency with sibling components; the
 * container exists as an extension point for future logic (e.g. Sentry
 * reporting of the surfaced error).
 * @module features/player-detail/components/PlayerDetailErrorState/PlayerDetailErrorStateContainer
 */

import PlayerDetailErrorStateView from "./PlayerDetailErrorStateView";

/** Props for PlayerDetailErrorStateContainer */
interface PlayerDetailErrorStateContainerProps {
  /** Error title displayed prominently */
  readonly title: string;
  /** Descriptive subtitle explaining the error */
  readonly subtitle: string;
  /** Callback fired when the retry button is pressed */
  readonly onRetry: () => void;
  /** Whether a retry is in flight — disables the CTA and shows a spinner */
  readonly isRetrying?: boolean;
}

/**
 * Container for the player detail error state — passes title, subtitle, retry
 * handler, and busy state to the presentation View
 * @param root0 - Component props
 * @param root0.title - Error heading text
 * @param root0.subtitle - Error description text
 * @param root0.onRetry - Handler for the retry CTA button
 * @param root0.isRetrying - Whether a retry is in progress (busy state)
 */
const PlayerDetailErrorStateContainer = ({
  title,
  subtitle,
  onRetry,
  isRetrying = false,
}: PlayerDetailErrorStateContainerProps) => (
  <PlayerDetailErrorStateView
    title={title}
    subtitle={subtitle}
    onRetry={onRetry}
    isRetrying={isRetrying}
  />
);

export default PlayerDetailErrorStateContainer;
